import axios from "axios";
import baseURL, { ticketBaseURL } from "../configs/api";

export type HealthCheck = () => Promise<boolean>;
export type TenantHealthCheck = (tenantId: string) => Promise<boolean>;

export const checkServerHealth = async (tenantId: string) => {
    try {
        const response = await axios.get(`${baseURL}health`,
            {
                timeout: 60000,
                headers: {
                    "X-Tenant-ID": tenantId
                }
            }
        );

        return response.status === 200;
    } catch (error) {
        console.log("Health check failed:", error);
        return false;
    }
}

export const checkTicketServerHealth = async () => {
    try {
        const response = await axios.get(`${ticketBaseURL}/rdRental/health`, {
            timeout: 60000
        });

        return response.status === 200;
    } catch (error) {
        console.log("Health check failed:", error);
        return false;
    }
}